/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue';

require('../front/bootstrap');
// Exposes window.ViluuConsent for the post-load `viluu:consent` listener in
// _header.blade.php. The synchronous <head> tracking gate reads the consent
// cookie directly, so it no longer needs this bundle to load first.
require('./utils/consent-gate-entry.js');

try {
  window.pushMessaging = require('./firebase').default;
} catch (e) {
  // console.error('This browser doesn\'t support the API\'s required to use the firebase SDK.');
  console.error(e.message);
}

import { default_locale, store } from '../front/vue_config';
import VueMixins from '../front/vue_mixins';

/*
 * Add site custom routes
 */
import routes from './routes';
import { localize } from 'vee-validate';

const router = require('../front/router').default;

router.addRoutes(routes);

require('./vue_components');


function loadLocaleSite(code) {
  return import(/* webpackChunkName: "js/vee-validate-locale/" */ `./vee-validate/locale/${code}.json`).then(locale => {
    localize(code, locale);
  });
}

loadLocaleSite(default_locale);

//Vue.component('online-card-component', require('../front/components/Profile/OnlineCardComponent').default);

// try {
//     require("./config-" + process.env.MIX_SITE_NAME);
// } catch (e) {
//     console.log("Site config not found");
// }

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.vApp = new Vue({
  el: '#app',
  store,
  router,
  mixins: [VueMixins],
  methods: {
    afterUserLoaded: function (userId) {

    }
  }
});

